function wrapEmojisWithSpan() {
    // Emoji-RegEx optimiert, auch für komplexe Emoji-Kombinationen und Variation Selectors
    const emojiRegex = /(?:\u2764\uFE0F|[\p{Emoji_Presentation}\p{Extended_Pictographic}])/gu;

    // Zielcontainer: Suche nach allen relevanten Textblasen
    const postTextContainers = document.querySelectorAll('.post-entry__text');

    // Iteriere über Zielcontainer
    postTextContainers.forEach((container) => {
        const textNodes = Array.from(container.childNodes);

        // Iteriere durch Kinder der Textknoten
        textNodes.forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE && emojiRegex.test(node.nodeValue)) {
                // Platziere Emojis in <span>-Tags, aber verändere NICHT das Original-Emoji
                const wrappedText = node.nodeValue.replace(emojiRegex, (emoji) => {
                    return `<span class="system_emoji">${emoji}</span>`;
                });

                // Ersetze Textknoten mit HTML
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = wrappedText;

                // Füge verarbeitete Emojis anstelle des Originaltextes ein
                while (tempDiv.firstChild) {
                    container.insertBefore(tempDiv.firstChild, node);
                }

                // Entferne den ursprünglichen Text
                container.removeChild(node);
            }
        });
    });
}

// Führe die Emoji-Wrapping-Funktion nach dem Laden der Seite aus
document.addEventListener('DOMContentLoaded', wrapEmojisWithSpan);